export function normalizeAdminRole(role: unknown): string {
  if (typeof role !== "string") {
    return "";
  }
  const trimmed = role.trim();
  return trimmed.length > 0 ? trimmed.toUpperCase() : "";
}

export function sessionRoleDiffersFromRtdb(
  sessionRole: string,
  rtdbRole: unknown
): boolean {
  const session = normalizeAdminRole(sessionRole);
  const rtdb = normalizeAdminRole(rtdbRole);
  if (!session || !rtdb) {
    return false;
  }
  return session !== rtdb;
}

export function isSessionExpClaimPast(
  claims: Record<string, unknown>,
  nowMs: number = Date.now()
): boolean {
  const exp = claims.session_exp;
  if (typeof exp !== "number" || !Number.isFinite(exp)) {
    return true;
  }
  return exp * 1000 <= nowMs;
}

if (__DEV__) {
  if (!sessionRoleDiffersFromRtdb("ADMIN", "COLLABORATOR")) {
    console.error("adminRoleSessionWatch: role mismatch");
  }
  if (!!sessionRoleDiffersFromRtdb("PUBLISHER", "publisher")) {
    console.error("adminRoleSessionWatch: same role different case");
  }
  if (!isSessionExpClaimPast({ session_exp: 1 })) {
    console.error("adminRoleSessionWatch: past session_exp");
  }
}
